module.exports = __webpack_public_path__ + "assets/img/18_1848_big.fb734c10.jpg";